// ------SAMPLE CALLS------

import { getToken, getUser } from "../../Utilities/Common";
import {
  getWithParamsAPICall,
  postAPICall,
  postAPICallwithFile,
} from "../axiosMethodCall";
//POST API -- append a new data to the db
export const createLaboratoryResult = async (
  info,
  patient_id,
  is_lab_dependent
) => {
  try {
    var formData = new FormData();
    formData.append("requester", getUser());
    formData.append("token", getToken());
    formData.append("patient_id", patient_id);
    formData.append("lab_test_id", info.lab_test_id ? info.lab_test_id : "");
    formData.append("result", info.result ? info.result : "");
    formData.append("result_date", info.result_date ? info.result_date : "");
    const response = await postAPICallwithFile(
      process.env.REACT_APP_LINK + "lab_results/create_multiple",
      formData
    );
    return response;
  } catch (error) {
    return { error: error.response };
  }
};

export const getLaboratoryResult = async (
  patient_id,
  assessment_id,
  lab_result_id,
  search
) => {
  try {
    var payload = {
      requester: getUser(),
      token: getToken(),
      patient_id,
      assessment_id,
      lab_result_id,
      search,
    };

    const response = await getWithParamsAPICall(
      process.env.REACT_APP_LINK + "lab_results/get",
      payload
    );
    return { data: response.data };
  } catch (error) {
    return { error: error.response };
  }
};

export const updateLaboratoryResult = async (
  info,
  patient_id,
  assessment_id
) => {
  try {
    var formData = new FormData();
    formData.append("requester", getUser());
    formData.append("token", getToken());
    formData.append("patient_id", patient_id);
    formData.append("lab_result_id", info.id);
    formData.append("lab_test_id", info.lab_test_id ? info.lab_test_id : "");
    formData.append("result", info.result ? info.result : "");
    formData.append("result_date", info.result_date ? info.result_date : "");

    const response = await postAPICallwithFile(
      process.env.REACT_APP_LINK + "lab_results/update",
      formData
    );

    return { data: response };
  } catch (error) {
    return { error: error.response };
  }
};

export const deleteLaboratoryResult = async (id) => {
  try {
    const response = await postAPICall(
      process.env.REACT_APP_LINK + "lab_results/delete",
      {
        requester: getUser(),
        token: getToken(),
        lab_result_id: id,
      }
    );
    return { data: response };
  } catch (error) {
    return { error: error.response };
  }
};
